import React, { useState } from "react";
import PropTypes from "prop-types";

const AuthContext = React.createContext({
  isLoggedIn: false,
  login: () => {},
  logout: () => {},
});

export const AuthContextProvider = (props) => {
  const localStorage = window.localStorage;
  const localEmail = localStorage.getItem("email");
  const localPassword = localStorage.getItem("password");

  let defaultLogin;
  if (localEmail && localPassword) {
    defaultLogin = true;
  } else {
    defaultLogin = false;
  }

  const [isIngelogd, setIsIngelogd] = useState(defaultLogin);

  //console.log("isIngelogd", isIngelogd);
  const userIsLoggedIn = !!isIngelogd;
  //console.log("userIsLoggedIn", userIsLoggedIn);

  const logoutHandler = () => {
    setIsIngelogd(false);
  };

  const loginHandler = (email, password) => {
    //console.log("email", email);
    //console.log("password", password);
    setIsIngelogd(true);
  };

  const contextValue = {
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

AuthContextProvider.propTypes = {
  children: PropTypes.node,
};

export default AuthContext;
